var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTumblrDesktopReblog = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 19,
  viewBox: "0 0 18 19",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M17.009 7.91v6.337s0 .633-.495 1.087c-.494.495-1.19.266-1.19.266H5v2.681s-.195.083-.364.119C3.091 17.178 0 14.54 0 14.54s3.102-2.284 4.653-3.2c.163-.402.347.375.347.375V13.6s9.636.37 9.932-.25c.087.051.112-1.226.116-2.556v-.745c-.002-.978-.013-1.85-.016-2.08V7.91zM12.373 0C13.918 1.822 17 3.56 17 3.56s-3.093 3.184-4.644 3.6c-.163.902-.356.125-.356.125V4.6s-9.283-.44-10 .3c-.2.644-.022 5.391-.022 5.391H0V4.753s.184-1.02.679-1.474A3.1 3.1 0 0 1 1.685 2.6H12V.719s.204-.083.373-.719"
})));
export default SvgTumblrDesktopReblog;